import { extractDataFromResponse, useErrorReporter } from '@mdlinx/frontend-shared';
import { RecoverEmailError, useRecoverEmailMutation } from 'generated/client';
import { messages } from 'lib/messages';
import * as React from 'react';

const { useEffect, useState } = React;

function translateError(error: RecoverEmailError): string {
  switch (error) {
    case RecoverEmailError.ExpiredOobCode:
      return messages.error.recoverEmail.expiredOobCode;
    case RecoverEmailError.InvalidOobCode:
      return messages.error.recoverEmail.invalidOobCode;
    case RecoverEmailError.Unknown:
      return messages.error.recoverEmail.unknown;
  }
}

export const RecoverEmailHandler: React.FC<{
  onSuccess: () => void;
  oobCode: string;
}> = ({ onSuccess, oobCode }) => {
  const errorReporter = useErrorReporter();
  const [recoverEmail] = useRecoverEmailMutation();
  const [message, setMessage] = useState('');

  useEffect(() => {
    recoverEmail({ variables: { input: { oobCode } } })
      .then(extractDataFromResponse)
      .then(({ recoverEmail }) => {
        switch (recoverEmail.__typename) {
          case 'RecoverEmailSuccess':
            return onSuccess();
          case 'RecoverEmailFailure':
            setMessage(translateError(recoverEmail.error));
        }
      })
      .catch(errorReporter.report);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <span style={{ color: 'red' }}>{message}</span>;
};
